export default {
      id: "logo-masbohdanecsko-usage",
      viewBox: "0 0 92.13 65.91",
      url: __webpack_public_path__ + "../images/sprites.svg#logo-masbohdanecsko",
      toString: function () {
        return this.url;
      }
    }